import React from "react";
import {form, Loader} from "@mc/mc-legacy";
import {Button, Card, CardBody} from "reactstrap";
import {withLang} from "../../i18n/withLang";
import {i18n} from "../../i18n/i18n";

const FormBody = form.FormBody;
const FormActions = form.FormActions;

class SubmitOnlyForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {onClose, handleSubmit, message, submitText, dialogTitle} = this.props;
        return (
            <div className={"edit-dialog-form"}>
                <FormBody>
                    {dialogTitle && <h2 className={"mt-3 mb-3"}>{dialogTitle}</h2>}
                    <Card className="mb-3">
                        <CardBody>
                            {message}
                        </CardBody>
                    </Card>
                </FormBody>
                <FormActions onClose={onClose} submitButton={false}>
                    <Button className={"pl-3 pr-3"} color="primary" outline onClick={onClose}>{i18n(this.props.lang, "button_Close")}</Button>
                    <Button
                        className={"ml-2"}
                        color={"primary"}
                        type={"submit"}
                        onClick={handleSubmit}
                    >
                        {submitText}
                    </Button>
                </FormActions>
            </div>
        );
    }
}
export default withLang(SubmitOnlyForm);
